export var SESSION_TYPES = {
    COURSE: 'course',
    SERVICE: 'service',
};
